import React, { FC } from 'react';
import { PageTitle, PageLink } from '../../../_mexablock/layout/core';
import { View } from './components/View';

const breadCrumbs: Array<PageLink> = [];

const EnviosPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Envíos</PageTitle>
      <View />
    </>
  );
};

export { EnviosPage };
